/**
 * Terrain name mappings ported from WarYes
 */
export const TERRAIN_NAMES_MAP = {
  ForetLegere: 'Forest',
  Ruin: 'Ruin',
  Batiment: 'Building',
  None: 'None',
};

const REVERSE_TERRAIN_NAMES_MAP: { [key: string]: string } = {};

for (const key in TERRAIN_NAMES_MAP) {
  if (Object.prototype.hasOwnProperty.call(TERRAIN_NAMES_MAP, key)) {
    const terrainKey = key as keyof typeof TERRAIN_NAMES_MAP;
    const reverseTerrainKey = TERRAIN_NAMES_MAP[terrainKey];
    REVERSE_TERRAIN_NAMES_MAP[reverseTerrainKey] = terrainKey;
  }
}

export { REVERSE_TERRAIN_NAMES_MAP };

